import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ExportOfferDocument, NewExportOfferDocument, TechnicalDocumentType } from "src/app/domain/models/ExportOfferDocument";

@Injectable({providedIn: 'root'})
export abstract class ExportOfferDocumentGateway {
  abstract create(document: NewExportOfferDocument): Observable<ExportOfferDocument>
  abstract update(document: ExportOfferDocument): Observable<ExportOfferDocument>
  abstract delete(exportOfferDocumentId: number): Observable<any>
  abstract getAllByExportOffer(exportOfferId: number): Observable<ExportOfferDocument[]>
  abstract getAllByImportOrder(orderId: string): Observable<ExportOfferDocument[]>
  abstract getAllFreeByProfile():Observable<ExportOfferDocument[]>
  abstract getAllAssignedByProfile():Observable<ExportOfferDocument[]>
  abstract copyExportDocumentToExportOffer(exportOfferId: number, exportOfferDocuments: number[]): Observable<ExportOfferDocument>
  abstract getAllTechnicalDocumentTypes(): Observable<TechnicalDocumentType[]>
  abstract assignExportOfferDocument(importOrderGuid: string, exportOfferDocuments: number[]): Observable<ExportOfferDocument>
  abstract deleteExportOfferDocument(orderId: number, exportOfferDocumentId: number): Observable<ExportOfferDocument>
}
